import {
  Platform,
  Pressable,
  Text,
  View,
  type StyleProp,
  type ViewStyle,
} from "react-native";
import type { LucideIcon } from "lucide-react-native";
import {
  pressLabel,
  usePressCapture,
} from "@src/packages/analytics/usePressCapture";

type Props = {
  label: string;
  onPress?: () => void;
  icon?: LucideIcon;
  blur?: number;
  backgroundColor?: string;
  borderColor?: string;
  style?: StyleProp<ViewStyle>;
};

export function GlassPillCTA({
  label,
  onPress,
  icon: Icon,
  blur,
  backgroundColor = "rgba(255, 255, 255, 0.1)",
  borderColor = "rgba(255, 255, 255, 0.2)",
  style,
}: Props) {
  const capturePress = usePressCapture("GlassPillCTA");
  const buttonStyle = [
    {
      flexDirection: "row" as const,
      alignItems: "center" as const,
      justifyContent: "center" as const,
      borderRadius: 999,
      borderWidth: 1,
      borderColor,
      backgroundColor,
      ...(Platform.OS === "web" && blur !== undefined
        ? { backdropFilter: `blur(${blur}px)` }
        : null),
      paddingVertical: 14,
      paddingHorizontal: 24,
      gap: 8,
    },
    style,
  ];

  const content = (
    <>
      <Text
        className="font-dm-sans"
        style={{
          fontSize: 15,
          fontWeight: "600",
          color: "#FFFFFF",
        }}
      >
        {label}
      </Text>
      {Icon ? <Icon size={16} color="#FFFFFF" /> : null}
    </>
  );

  if (!onPress) return <View style={buttonStyle}>{content}</View>;

  return (
    <Pressable
      onPress={() => {
        capturePress(pressLabel(label), "glass_pill_cta");
        onPress();
      }}
      style={buttonStyle}
    >
      {content}
    </Pressable>
  );
}
